module.exports = __webpack_public_path__ + "static/media/placeholder.c14e98d4.png";